<template>
  <div>
    <!-- datatable riders -->
    <v-row>
      <v-col md="12" sm="12" cols="12" v-if="isSingleRegistration">
        <WarningAlert>
          <p class="mb-0">{{ $tc(`membershipRegistration.step_part_description_1`) }}</p>
          <p class="mb-0">{{ $tc(`membershipRegistration.step_part_description_2`) }}</p>
          <p class="mb-0">{{ $tc(`membershipRegistration.step_part_description_3`) }}</p>
        </WarningAlert>
      </v-col>
      <v-col md="12" sm="12" cols="12" v-else>
        <p class="mb-0">
          {{ $t(`membershipRegistration.step3_description_1`) }}
        </p>
        <p class="mb-0">
          {{ $t(`membershipRegistration.step3_description_2`) }}
        </p>
      </v-col>
      <v-col md="12" sm="12" cols="12" class="pb-0">
        <v-btn
          :color="`${buttonColor}`"
          class="btn_next mr-12 my-1"
          @click="addRider"
          >{{ $t("registerEvent.add_part") }}</v-btn
        >
        <v-btn
          v-if="emergencyContactAll"
          :color="`${buttonColor}`"
          class="btn_next mr-12 my-1"
          @click="addEmergencyContact"
          >{{ $t("registerEvent.add_emergency_contact") }}</v-btn
        >
        <v-btn
          v-if="vehiclesAll"
          :color="`${buttonColor}`"
          class="btn_next mr-12 my-1"
          v-model="step"
          @click="addVehicles"
          >{{ $t("registerEvent.add_vehicles") }}</v-btn
        >
      </v-col>
      <v-col md="12" sm="12">        
          <v-data-table
            :key="key"
            :headers="ridersHeaders"
            :items="registrationObj.participants"
            sort-by="name"
            class="elevation-1 dt_part"
            item-key="firstName"
            :item-class="rowClass"
            dense
          :no-data-text="$t('dataTable.noDataText')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"
          >
            <template v-slot:[`item.selected`]="{ item }" v-if="itemOrg.totalRegistrantAllowed && itemOrg.totalRegistrantAllowed > 1">
                <div 
                  @click="handleCheckboxClick(item)"
                  :class="{ 'disabled-checkbox-wrapper': isLimitReached && !item.selected }"
                >
                  <v-checkbox               
                    v-model="item.selected"
                    @change="updateCheck($event, item.userId)"
                    :disabled="(isLimitReached && !item.selected) || item.hasMembership"
                  ></v-checkbox>
                </div>
            </template>
            <template v-slot:[`item.radio`]="{ item }" v-else>
              <input 
                type="radio"
                :value="item.userId"
                :checked="selectedParticipant === item.userId"
                @change="handleRadioChange(item)"
                :name="'participant-radio'"
                class="custom-radio"
                :disabled="item.hasMembership"
              >
            </template>
            
            <template v-slot:[`item.status`]="{ item }">
              <span
                v-if="item.disabled"
                :style="`${item.statusColor != '' ? `color: ${item.statusColor}` : ''};`">
                {{ item.status }}
                <v-icon v-if="item.hasMembership" color="primary" @click="showHasMembershipDialog(item)">fa far fa-info-circle</v-icon>
              </span>
              <template v-else>
                {{ item.status }}
                <v-icon v-if="item.hasMembership" color="primary" @click="showHasMembershipDialog(item)">fa far fa-info-circle</v-icon>
              </template>
            </template>
            <template v-slot:[`item.emergencyContact`]="{ item }">
              <v-icon v-if="item.emergencyContact" color="green"
                >fas fa-check-circle</v-icon
              >
              <span v-else style="color:red;">{{
              $t("riders.emergency_contact_missing")
              }}</span>
            </template>
            <template v-slot:[`item.vehicle`]="{ item }">
              <span v-if="item.vehicleColor" style="color:red;">{{
                item.vehicle
              }}</span>
              <v-icon v-else color="green">fas fa-check-circle</v-icon>
            </template>
          </v-data-table>        
      </v-col>
    </v-row>

    <v-row>
      <v-col md="6" sm="6" cols="6" class="text-left">
        <v-btn
          v-if="!defaultRegistration"
          :color="`${buttonColor}`"
          class="btn_next"
          v-model="step"
          @click="nextStep(stepBack)"
          >{{ $t("registerEvent.prev") }}</v-btn
        >
      </v-col>
      <v-col md="6" sm="6" cols="6" class="text-right">
        <v-btn
          :color="`${buttonColor}`"
          class="btn_next"
          v-model="step"
          @click="validateRiders"
          >{{ $t("registerEvent.next") }}</v-btn
        >
      </v-col>
    </v-row>
    <v-dialog v-model="hasMembershipDialog" width="500">
      <v-card>
        <v-card-title>
          {{ $t("membershipRegistration.active_membership_title") }}
        </v-card-title>
        <v-card-text class="pb-0">
          <p>{{ $t("membershipRegistration.active_membership_message") }}</p>
          <v-btn
            :color="buttonColor"
            class="btn_next mt-2 text-white"
            @click="goToManageClasses"
          >{{ $t("membershipRegistration.go_to_manage_classes") }}</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeHasMembershipDialog">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      
  </div>
</template>

<script>
import { VRow, VCol, VBtn, VDataTable, VIcon, VCheckbox, VDialog, VCard, VCardTitle, VCardText, VCardActions, VSpacer } from "vuetify/lib";
import LocalStorageService from "@/services/LocalStorageService";
import WarningAlert from "@/components/alert/WarningAlert";

export default {
  components: {
    VRow,
    VCol,
    VBtn,
    VDataTable,
    VIcon,
    VCheckbox,
    WarningAlert,
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer
  },
  props: {
    step: Number,
    registrationObj: Object,
    isMembership: Boolean,
    isVehicles: Boolean,
    isSponsors: Boolean,
    disabledStep3: Boolean,
    itemOrg: Object,
    defaultRegistration: Boolean,
    orgDefaultId: Number,
  },
  data() {
    return {
      buttonColor: "#000",
      key: 0,
      selectedRadios: {},
      selectedParticipant: null,
      hasMembershipDialog: false,
      hasMembershipDialogUserId: null,
    };
  },
  computed: {
    ridersHeaders() {
      let header = [
        {
          text: this.itemOrg.totalRegistrantAllowed && this.itemOrg.totalRegistrantAllowed > 1 ? this.$t("registerEvent.selected") : '',
          value: this.itemOrg.totalRegistrantAllowed && this.itemOrg.totalRegistrantAllowed > 1 ? "selected" : "radio",
          width: "10%", 
          sortable: false,
        },
        { text: this.$t("riders.first_name"), align: "", value: "fName" },
        { text: this.$t("riders.last_name"), value: "lName" },
        { text: this.$t("riders.status"), value: "status" },
        {
          text: this.$t("riders.emergency_contact"),
          value: "emergencyContact",
          align: "center",
        },
      ];
      if (this.isVehicles) {
        header.push({
          text: this.$t("riders.vehicles"),
          value: "vehicle",
          align: "center",
        });
      }
      return header;
    },
    stepBack() {
      const backStep = this.step - 1;
      return backStep > 0 ? backStep : 1;
    },
    emergencyContactAll() {
      if (this.registrationObj) {
        const emergencyContactFailed = this.registrationObj.participants.filter(
          (el) => {
            return el.emergencyContact == 0;
          }
        );
        return emergencyContactFailed.length > 0;
      }
      return false;
    },
    vehiclesAll() {
      if (this.registrationObj) {
        const vehicleFailed = this.registrationObj.participants.filter((el) => {
          return el.vehicle != "";
        });
        return vehicleFailed.length > 0;
      }
      return false;
    },
    isSingleRegistration() {
      return this.itemOrg.totalRegistrantAllowed && this.itemOrg.totalRegistrantAllowed == 1;
    },
    isLimitReached() {
      if (!this.registrationObj.participants) return false;
      
      const selectedCount = this.registrationObj.participants.filter(p => p.selected).length;
      return this.itemOrg.totalRegistrantAllowed && selectedCount >= this.itemOrg.totalRegistrantAllowed;
    }
  },
  methods: {
    showHasMembershipDialog(item) {
      this.hasMembershipDialogUserId = item ? item.userId : null;
      this.hasMembershipDialog = true;
    },
    closeHasMembershipDialog() {
      this.hasMembershipDialog = false;
      this.hasMembershipDialogUserId = null;
    },
    goToManageClasses() {
      this.hasMembershipDialog = false;
      this.$router.push({
        name: "MembershipClasses",
        query: {
          userId: this.hasMembershipDialogUserId || undefined,
          organizationId: this.itemOrg ? this.itemOrg.id : undefined
        }
      });
    },
    handleRadioChange(item) {
      this.selectedParticipant = item.userId;
      let data = {
        newValue: true,
        id: item.userId
      }
      this.registrationObj.participants.forEach(participant => {
        if (participant.userId !== item.userId) {
          participant.selected = false;
        }else{
          participant.selected = true;
        }
      });
      this.$emit("updateParticipants", data);
    },
    nextStep(step) {
      this.$emit("nextStep", step);
    },
    validateRiders() {
      this.$emit("validateRiders");
    },
    addRider() {
      LocalStorageService.setItem("link_back_spect", this.$route.name);
      LocalStorageService.setItem("org_reg", this.itemOrg);
      LocalStorageService.setItem("add_part_reg_legacy", 1);
      this.$router.push({
        name: "RidersCreate",
      });
    },
    addEmergencyContact() {
      this.$router.push({
        name: "EmergencyContact",
      });
    },
    updateCheck(newValue, id) {
      this.$emit("updateParticipants", { newValue, id });
    },
    handleCheckboxClick(item) {
      if (this.isLimitReached && !item.selected) {
        const limit = this.itemOrg.totalRegistrantAllowed;
        const msg = limit <= 1 
          ? this.$t("membershipRegistration.limit-member")
          : this.$t("membershipRegistration.limit-members", { limit });
        this.$emit("showLimitMessage", { msg, color: "error" });
      }
    },
    addVehicles() {
      this.$router.push({
        name: "Vehicles",
      });
    },
    rowClass(item) {
      let rowClass = "";
      if (item.disabled || item.disabledStatus) rowClass = "grayC";
      return rowClass;
    },
  },
  created() {
    this.buttonColor = this.$store.getters.env.get("VUE_APP_BUTTON_COLOR");
    this.key++;
  },
};
</script>

<style>
.custom-radio {
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin: 2px 0px;
}

@media (max-width: 960px) {
  .next1 {
    display: block;
  }
  .next2Part {
    display: none;
  }
}

@media (min-width: 960px) {
  .next1 {
    display: none;
  }
  .next2Part {
    display: block;
  }
}

.disabled-checkbox-wrapper {
  cursor: not-allowed;
  opacity: 0.6;
  position: relative;
}

.disabled-checkbox-wrapper >>> .v-input--checkbox {
  opacity: 0.6;
}

.disabled-checkbox-wrapper >>> .v-input--checkbox .v-input--selection-controls__input {
  cursor: not-allowed;
}
.text-white {
  color: #fff !important;
}
</style>
